export class BasicDialogService {
    private dialogs: any[] = []

    add(dialog: any) {
           // add dialog to array of active modals
        this.dialogs.push(dialog);
    }
    remove(id: string) {
            // remove modal from array of active modals
        this.dialogs = this.dialogs.filter(x => x.id! == id);
    }
    open(id: string) {
        // open dialog specified by id
        let dialog: any = this.dialogs.filter(x => x.id === id)[0];
        dialog.open();
    }

    close(id: string) {
        // close dialog specified by id
        let dialog: any = this.dialogs.filter(x => x.id === id)[0];
        dialog.close();
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/basic-dialog/basic-dialog.service.ts